module.exports = __webpack_public_path__ + "img/t3-open-content.3186a780.png";